import React from 'react';
import { useNavigate } from 'react-router-dom';
import { User, Flame, Sparkles, CheckCircle } from 'lucide-react';
import { useApp } from '../context/AppContext';
import './WelcomeScreen.css';

export default function WelcomeScreen() {
  const { user } = useApp();
  const navigate = useNavigate();

  const firstName = user?.first_name || user?.name?.split(' ')[0] || 'da';

  return (
    <div className="welcome-screen">
      <div className="welcome-screen__bg">
        <div className="welcome-bg-blob welcome-bg-blob--1" />
        <div className="welcome-bg-blob welcome-bg-blob--2" />
      </div>

      <div className="welcome-screen__content animate-fadeInUp">
        <div className="welcome-screen__confetti" aria-hidden="true">
          <Sparkles size={48} strokeWidth={1.2} />
        </div>

        <div className="welcome-screen__logo">
          <Flame size={28} color="white" fill="white" />
        </div>

        <h1 className="welcome-screen__title">
          Willkommen bei<br />LetsCareers!
        </h1>

        <div className="welcome-screen__name">
          Hallo {firstName}!
        </div>

        <div className="welcome-screen__verified">
          <span className="welcome-verified-badge"><CheckCircle size={14} /> Dein Account ist bestätigt</span>
        </div>

        <p className="welcome-screen__subtitle">
          Du bist jetzt Teil der Community – bereit, deinen Traumjob zu finden?
        </p>

        <div className="welcome-screen__actions">
          <button
            className="welcome-btn welcome-btn--primary"
            onClick={() => navigate('/profile')}
          >
            <User size={18} />
            Profil vervollständigen
          </button>
          <button
            className="welcome-btn welcome-btn--secondary"
            onClick={() => navigate('/')}
          >
            <Flame size={18} />
            Jobs entdecken
          </button>
        </div>
      </div>
    </div>
  );
}
